import isAppStore from "@/lib/is-platform/is-app-store"
import isIos from "@/lib/is-platform/is-ios"

export default () =>
  (isAppStore() && isIos()) ||
  !!(navigator?.serviceWorker && window.PushManager && window.Notification)
